module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record",
    attrs: {
      "id": "RECORD-SWF"
    }
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("网页版无法使用此功能,请下载专业版!")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "mac"
  }, [_c('span', {
    staticClass: "icon-mac"
  }), _vm._v(" "), _c('span', [_vm._v("Mac版")])]), _vm._v(" "), _c('div', {
    staticClass: "windows"
  }, [_c('span', {
    staticClass: "icon-windows"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  }), _c('span', {
    staticClass: "path4"
  })]), _vm._v(" "), _c('span', {
    staticClass: "plat"
  }, [_vm._v("Windows版")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a855b786","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Record/Record.vue
// module id = 404
// module chunks = 0